import React from 'react';

const Classes: React.FC = () => {
  const classes = [
    {
      title: '((B)) Pilates',
      description: 'Bodyflows, yoga and pilates moves with basic bouncing routines ideal for agility.',
      duration: '45 mins',
      intensity: 'Medium',
      image: 'bounce_banner.png'
    },
    {
      title: '((BOUNCE)) BLAST',
      description: 'Bounce blast is our slightly shorter 45 minute class with the same amazing choreo as our standard bounce class. By adding hand weights you can intensify the workout to focus more on the upper body.',
      duration: '45 mins',
      intensity: 'High',
      image: 'bounce_banner.png'
    }
  ];

  return (
    <div className="classes-page">
      <section className="section">
        <div className="container">
          <h1 className="section-title">Our Classes</h1>
          <div className="grid grid-2">
            {classes.map((classItem, index) => (
              <div key={index} className="card class-card" style={{ 
                display: 'flex', 
                flexDirection: 'column',
                height: '100%'
              }}>
                <div className="class-image" style={{ 
                  width: '100%', 
                  height: '120px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  overflow: 'hidden'
                }}>
                  <img 
                    src={`/images/${classItem.image}`} 
                    alt={classItem.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                  />
                </div>
                <div className="class-content" style={{ 
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}>
                  <div>
                    <h3>{classItem.title}</h3>
                    <p>{classItem.description}</p>
                  </div>
                  <div>
                    <div className="class-details" style={{ marginTop: '20px' }}>
                      <span>Duration: {classItem.duration}</span>
                    </div>
                    <div style={{ marginTop: '20px' }}>
                      <a href="https://bookwhen.com/bouncefitdubai" target="_blank" rel="noopener noreferrer" className="button">
                        Book
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-light">
        <div className="container">
          <h2 className="section-title">Class Schedule</h2>
          <div className="schedule-grid">
            <div className="schedule-item">
              <h3>((B)) Pilates</h3>
              <div className="class-time">
                <p>Check our timetable for popup classes</p>
              </div>
              <a 
                href="https://maps.app.goo.gl/eFM2bUQqaQGvkFN38" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="button"
              >
                Get Directions
              </a>
            </div>
            <div className="schedule-item">
              <h3>Wednesday</h3>
              <div className="class-time">
                <p>08:45 - ((BOUNCE))</p>
                <p>Crimson Chambers Yoga Studio, The Sustainable City Plaza, Ground Floor</p>
              </div>
              <a 
                href="https://maps.app.goo.gl/eFM2bUQqaQGvkFN38" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="button"
              >
                Get Directions
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Classes; 